import React from 'react';
import { Icon } from '@iwoca/orion';
import clsx from 'clsx';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import { PostcodeInput } from '../PostcodeInput/PostcodeInput';
import signupFormStyles from '../SignupForm/SignupForm.module.css';
import { AddressTabs } from './AddressTabs/AddressTabs';
import {
  TMultiAddressInput,
  useMultiAddressInput,
} from './MultiAddressInput.helpers';
import styles from './MultiAddressInput.module.css';

export const MultiAddressInput = ({
  personRole,
  personIndex,
}: TMultiAddressInput) => {
  const {
    additionalAddresses,
    appendAddress,
    removeAddress,
    addresses,
    errors,
    targetAddressIndex,
    setTargetAddressIndex,
  } = useMultiAddressInput({ personRole, personIndex });

  return (
    <div>
      <AddressTabs
        addresses={addresses}
        targetAddressIndex={targetAddressIndex}
        setTargetAddressIndex={setTargetAddressIndex}
        errors={errors}
        personIndex={personIndex}
        personRole={personRole}
      />

      <div
        className={clsx(signupFormStyles.formField, styles.addressField, {
          [styles.focused]: targetAddressIndex === 0,
        })}
      >
        <PostcodeInput
          personRole={personRole}
          personIndex={personIndex}
          addressIndex={0}
        />
      </div>

      {additionalAddresses.map((_, index) => {
        const addressIndex = index + 1;

        return (
          <div
            data-testid={`secondary-address-${addressIndex}`}
            key={index}
            className={clsx(signupFormStyles.formField, styles.addressField, {
              [styles.focused]: targetAddressIndex === addressIndex,
            })}
          >
            <PostcodeInput
              postcodeLabel={`Residential postcode (Address ${
                addressIndex + 1
              })`}
              addressOption="secondaryAddress"
              personRole={personRole}
              personIndex={personIndex}
              addressIndex={addressIndex}
            />
            <ButtonLink
              type="button"
              className={styles.secondaryAddressCancel}
              data-testid={`delete-secondary-address-${addressIndex}`}
              onClick={() => removeAddress(addressIndex)}
            >
              <Icon fontSize="1.4rem" icon="trashOutline" />
            </ButtonLink>
          </div>
        );
      })}

      {addresses.length < 5 && (
        <ButtonLink
          type="button"
          onClick={() => {
            appendAddress({ residential_status: undefined });
          }}
          className={styles.addAddressButton}
        >
          <Icon icon="plus" />
          Add another address
        </ButtonLink>
      )}
    </div>
  );
};
